module.exports = __webpack_public_path__ + "static/media/fly0119.2fce5947.webp";